module.exports = __webpack_public_path__ + "media/images/emblems/Sufers_wappen-2dcd087b4ecaba55cbf11e2b5df44dfc.svg";